import type { TFunction } from 'i18next';
import type {
  FieldError,
  FieldValues,
  UseControllerProps,
} from 'react-hook-form';
import { isObject } from 'lodash';

export const getFormErrorText = <TFieldValues extends FieldValues>(
  error: FieldError,
  rules: UseControllerProps<TFieldValues>['rules'] | undefined,
  t: TFunction<'translation', undefined>,
): string | undefined => {
  switch (error.type) {
    case 'required':
      return t('form-error.required');
    case 'minLength':
      return isObject(rules?.minLength)
        ? rules.minLength.message
        : t('form-error.min-length', {
            minLength: rules?.minLength,
          });
    case 'maxLength':
      return isObject(rules?.maxLength)
        ? rules.maxLength.message
        : t('form-error.max-length', {
            maxLength: rules?.maxLength,
          });
    case 'pattern':
      return t('form-error.pattern');
    default:
      return error.message?.length ? error.message : undefined;
  }
};
